import { HTMLSelect, HTMLSelectProps } from '../ui/html-select'
import { AmazonAPIState } from '../../util/contstants'
import React from 'react'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'

interface StateSelectProps extends Omit<HTMLSelectProps, 'onChange' | 'className'> {
    onChange: (state: number) => void
    className?: ClassValue
}

export const StateSelect = ({ onChange, className, ...rest }: StateSelectProps) => {
    return (
        <HTMLSelect
            {...rest}
            className={classNames(className)}
            iconProps={{ icon: 'caret-down' }}
            options={[
                { label: 'Enabled', value: AmazonAPIState.RESUME },
                { label: 'Paused', value: AmazonAPIState.PAUSE },
                { label: 'Archived', value: AmazonAPIState.ARCHIVE },
            ]}
            onChange={(e) => onChange(Number(e.target.value))}
        />
    )
}
